import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import jsPDF from 'jspdf';
import cabeceraCert from '../../assets/cabeceraCat.png';
import { useSelector } from 'react-redux';
import { fechaHoraActualBoliviaSoloVista } from '../../util/valueCalculator';
import { addHeader } from '../UI/TemplatePrintModals';
import { formatearFechaSimple } from '../../util/customFormatter';

const CustomPrintCert2 = ({ show, handleClose, afiliado, numeroCertificado, aserv, qrDataURL, certObjectText, copia }) => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const { nombre:nombreUsuario } = useSelector(state => state.sesion);

    useEffect(() => {
        if (show) {
            generatePDF();
        }
    }, [show]);

    const generatePDF = () => {
        const doc = new jsPDF({ orientation: 'portrait', unit: 'px', format: 'letter' });
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const marginTop = 35;
        const marginBottom = 60;
        const marginLeftRight = 40;
        const headerHeight=40;
        const day = new Date().getDate();
        const month = new Date().toLocaleString('es-ES', { month: 'long' });
        const year = new Date().getFullYear();

        const pronoun = afiliado.persona.genero === 'FEMENINO' ? 'la' : 'el';
        const pronounInteresado = afiliado.persona.genero === 'FEMENINO' ? 'de la interesada' : 'del interesado';
        const inscritoHabilitado = afiliado.persona.genero === 'FEMENINO' ? 'inscrita' : 'inscrito';
        const habilitadoContextual = afiliado.persona.genero === 'FEMENINO' ? 'habilitada' : 'habilitado';

        // Marca de agua si es copia (B O R R A D O R)
        if (copia) {
            doc.setFontSize(60);
            doc.setTextColor(200, 200, 200);
            doc.text('S I N   V A L I D E Z', pageWidth / 2, pageHeight / 2, {
                align: 'center',
                angle: 10,
            });
        }
        doc.setTextColor(10, 10, 10);
        // Cabecera
        addHeader({doc, showPageNumber:false, headerHeight, marginLeftRight, marginTop});

        // Número de Certificado
        doc.setFont('times', 'bold');
        doc.setFontSize(13);
        doc.text(`Nº ${numeroCertificado}`, pageWidth - marginLeftRight, marginTop + 20, { align: 'right' });

        // Título
        doc.setFont('times', 'bold');
        doc.setFontSize(18);
        doc.text('CERTIFICADO DE INSCRIPCIÓN', pageWidth / 2, marginTop + 80, { align: 'center' });

        doc.setFont('times', 'italic');
        doc.setFontSize(10);
        doc.text('(Decreto Supremo Nº 25905 de 05 de Septiembre de 2000)', pageWidth / 2, marginTop + 95, { align: 'center' });

        // Texto del Colegio
        doc.setFont('times', 'normal');
        doc.setFontSize(12);
        doc.text('La Asociación del Colegio de Arquitectos de Tarija', marginLeftRight, marginTop + 120);

        // Certificación
        doc.setFont('times', 'bold');
        doc.setFontSize(15);
        doc.text('CERTIFICA:', marginLeftRight, marginTop + 140);

        doc.setFont('times', 'normal');
        doc.setFontSize(12);
        doc.text(
            `Que, ${pronoun} ARQ. ${afiliado.persona.nombre} ${afiliado.persona.apellido1 || ""} ${afiliado.persona.apellido2 || ""}, con C.I. ${afiliado.persona.ci}, Grado académico de ARQUITECTO, está ${inscritoHabilitado} en el Registro Nacional de Arquitectos de Bolivia (Ley 1373 de 13 de noviembre de 1992) desde ${formatearFechaSimple(afiliado.fecha_reg_cab)}, con el Registro Nº ${afiliado.num_reg}, encontrándose ${habilitadoContextual} legalmente para ejercer la profesión en todo el territorio nacional.`,
            marginLeftRight,
            marginTop + 165,
            { maxWidth: pageWidth - marginLeftRight * 2, align: 'justify' }
        );

        doc.text(
            `El presente certificado se extiende a solicitud ${pronounInteresado} con el objeto determinado de:`,
            marginLeftRight,
            marginTop + 220,
            { maxWidth: pageWidth - marginLeftRight * 2, align: 'justify' }
        );

        const textStartY = marginTop + 250;
        const blockBottom = marginTop + 350; 
        const availableHeight = blockBottom - textStartY;
        const lineHeight = 12;

        doc.setFont("times", "normal");

        // ----------------------------
        // 1. Preparar líneas combinadas
        // ----------------------------
        const rawLines = certObjectText.trim().split("\n");

        // Medir ancho máximo de etiquetas
        let maxLabelWidth = 0;
        rawLines.forEach((line) => {
        const parts = line.split(":");
        if (parts.length >= 2) {
            const label = parts[0] + ":";
            const labelWidth = doc.getTextWidth(label);
            if (labelWidth > maxLabelWidth) maxLabelWidth = labelWidth;
        }
        });

        const col1X = marginLeftRight;
        const col2X = marginLeftRight + maxLabelWidth + 10;

        // Unir líneas con la misma clave
        let combinedLines = [];
        let buffer = "";
        rawLines.forEach((line) => {
        if (line.includes(":")) {
            if (buffer) combinedLines.push(buffer.trim());
            buffer = line;
        } else {
            buffer += "\n" + line;
        }
        });
        if (buffer) combinedLines.push(buffer.trim());

        // ----------------------------
        // 2. Calcular altura total
        // ----------------------------
        let blockHeight = 0;
        combinedLines.forEach((line) => {
        const parts = line.split(":");
        if (parts.length >= 2) {
            const value = parts.slice(1).join(":").trim();
            const wrappedValue = doc.splitTextToSize(value, pageWidth - col2X - marginLeftRight);
            blockHeight += wrappedValue.length * lineHeight;
        } else {
            const wrappedLine = doc.splitTextToSize(line, pageWidth - (2 * marginLeftRight));
            blockHeight += wrappedLine.length * lineHeight;
        }
        });

        // Calcular punto inicial para centrar en el bloque
        let y = textStartY + (availableHeight - blockHeight) / 2;

        // ----------------------------
        // 3. Dibujar texto
        // ----------------------------
        combinedLines.forEach((line) => {
        const parts = line.split(":");
        if (parts.length >= 2) {
            const label = parts[0] + ":";
            const value = parts.slice(1).join(":").trim();

            const wrappedValue = doc.splitTextToSize(value, pageWidth - col2X - marginLeftRight);

            doc.setFont("times", "bold");
            doc.text(label, col1X, y);

            doc.setFont("times", "normal");
            doc.text(wrappedValue, col2X, y, { 
            maxWidth: pageWidth - col2X - marginLeftRight, 
            align: 'justify' 
            });

            y += wrappedValue.length * lineHeight;
        } else {
            const wrappedLine = doc.splitTextToSize(line, pageWidth - (2 * marginLeftRight));

            doc.setFont("times", "normal");
            doc.text(wrappedLine, col1X, y, { 
            maxWidth: pageWidth - (2 * marginLeftRight), 
            align: 'justify' 
            });

            y += wrappedLine.length * lineHeight;
        }
        });

        doc.setFont('times', 'normal');
        doc.text(
            'Es cuanto se certifica en honor a la verdad y para los fines consiguientes.',
            marginLeftRight,
            marginTop + 370,
            { maxWidth: pageWidth - marginLeftRight * 2, align: 'justify' }
        );

        // Fecha
        doc.text(`Tarija, ${day} de ${month} de ${year}`, marginLeftRight, marginTop + 390);

        doc.text('Cc/Archivo', marginLeftRight, pageHeight - 30);

        // COLEGIO DEPARTAMENTAL
        doc.setFont('times', 'bold');
        doc.text('ASOCIACIÓN DEL COLEGIO DEPARTAMENTAL DE TARIJA', marginLeftRight, marginTop + 410);

        // Pie
        doc.setFont('times', 'bold');
        doc.setFontSize(8);
        doc.text('El presente certificado tiene validez de 30 días.', pageWidth / 2, pageHeight - marginBottom, { align: 'center' });
        doc.text('"Arquitectura Atribución de Arquitectos"', pageWidth / 2, pageHeight - marginBottom + 10, { align: 'center' });

        doc.setFont('times', 'normal');
        doc.setFontSize(8);
        doc.text(
            'Calle La Madrid # 615 casi Esq. Junín - Contacto: (+591) 68705939 - cat.tarija@gmail.com',
            pageWidth / 2,
            pageHeight - 30,
            { align: 'center' }
        );
        doc.text('Tarija - Bolivia', pageWidth / 2, pageHeight - 20, { align: 'center' });
        doc.setFontSize(6);
        doc.text(
            `Impreso el: ${fechaHoraActualBoliviaSoloVista()} por: ${nombreUsuario || 'Desconocido'}`,
            pageWidth - marginLeftRight,
            pageHeight - 10,
            { align: 'right' }
        );

        // QR Code
        if (qrDataURL) {
            doc.addImage(qrDataURL, 'PNG', pageWidth - marginLeftRight - 80, pageHeight - marginBottom - 88, 80, 80);
        }

        const pdfBlob = doc.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setPdfUrl(pdfUrl);
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Vista Previa del Certificado</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {pdfUrl ? (
                    <iframe src={pdfUrl} width="100%" height="500px" title="Vista previa del certificado" />
                ) : (
                    <p>Cargando vista previa...</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
                <Button variant="primary" onClick={() => window.open(pdfUrl, '_blank')}>
                    Descargar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CustomPrintCert2;
